// @flow
import { createAction } from 'redux-actions';

export const getDatasets = createAction('GET_DATASETS');
export const getDatasetsSuccess = createAction('GET_DATASETS_SUCCESS');
export const getDatasetsFailure = createAction('GET_DATASETS_FAILURE');

export const createDataset = createAction('CREATE_DATASET');
export const createDatasetSuccess = createAction('CREATE_DATASET_SUCCESS');
export const createDatasetFailure = createAction('CREATE_DATASET_FAILURE');

export const deleteDataset = createAction('DELETE_DATASET');
export const deleteDatasetSuccess = createAction('DELETE_DATASET_SUCCESS');
export const deleteDatasetFailure = createAction('DELETE_DATASET_FAILURE');

export const updateDataset = createAction('UPDATE_DATASET');
export const updateDatasetSuccess = createAction('UPDATE_DATASET_SUCCESS');
export const updateDatasetFailure = createAction('UPDATE_DATASET_FAILURE');

export const datasetPoll = createAction('DATASET_POLL', (payload) => payload, (payload, meta) => meta);
export const datasetPollSuccess = createAction('DATASET_POLL_SUCCESS');
export const datasetPollFailure = createAction('DATASET_POLL_FAILURE');
